import React from 'react';
import { ArrowTurnDownIcon, Box, Inscription, RawButton } from '@common-fe/common-fe';
import styled from 'styled-components';

import { OrganizationPathItem } from '../UnappliedFunds.types';

const PathButton = styled(RawButton)`
  padding: ${({ theme }) => `${theme.spacings.spacing2} ${theme.spacings.spacing4}`};
  border-radius: ${({ theme }) => theme.rounds.smallRound};

  &:hover {
    background-color: ${({ theme }) => theme.colors.module};
  }
`;

interface Props {
  items: OrganizationPathItem[];
  onSelect: (organizationId: string) => void;
}

const OrganizationPath: React.FC<Props> = ({ items, onSelect }) => (
  <Box data-testid="organization-path" direction="row" align="center" gap="spacing4">
    {items.map(({ id, name }) => (
      <Box key={id} direction="row" align="center" gap="spacing4">
        <PathButton data-testid={`organization-path_item_${id}`} onClick={() => onSelect(id)}>
          <Inscription size="14px" weight="normal" lineHeight="20px" textAlign="center" color="textBody">
            {name}
          </Inscription>
        </PathButton>
        <Inscription color="textDisabled">/</Inscription>
      </Box>
    ))}
    <ArrowTurnDownIcon size="12px" color="iconSecondary" />
  </Box>
);

export default OrganizationPath;
